// extracted by mini-css-extract-plugin
export default {"container":"SearchVideoList_container__UrIrE"};